(function(){'use strict';
// Phase 1: Defer non-critical JavaScript
// This script defers third-party scripts to improve checkout responsiveness

// Defer Klaviyo
if(window.Klaviyo){window.Klaviyo.defer=true;}
const deferKlaviyo=()=>{const s=document.createElement('script');s.src='https://static-tracking.klaviyo.com/onsite/js/klaviyo.js?v=1';s.async=true;document.head.appendChild(s);};
window.addEventListener('load',deferKlaviyo);

// Defer Facebook Pixel
if(window.fbq){window.fbq.disablePushState=true;}
const deferFacebook=()=>{const s=document.createElement('script');s.src='https://connect.facebook.net/en_US/fbevents.js';s.async=true;document.head.appendChild(s);};
window.addEventListener('load',deferFacebook);

// Defer Clarity
const deferClarity=()=>{const s=document.createElement('script');s.src='https://www.clarity.ms/tag/'+window.clarity_tag;s.async=true;document.head.appendChild(s);};
window.addEventListener('load',deferClarity);

// Ensure checkout button is interactive immediately
document.addEventListener('DOMContentLoaded',()=>{
  const checkoutBtn=document.getElementById('checkout');
  if(checkoutBtn){
    checkoutBtn.style.pointerEvents='auto';
    checkoutBtn.disabled=false;
  }
});

console.log('Phase 1: Checkout optimization loaded');
})();